module.exports = __webpack_public_path__ + "static/media/news.c11fa83c.png";


//////////////////
// WEBPACK FOOTER
// ./src/home/images/news.png
// module id = 531
// module chunks = 8